'use strict'

// utility class
import ApplyClass from '../Utils/ApplyClass'

import Form from '../Controller/Form'

// 他案件から持ってきた
import Validate from '../View/Form/Validate'
import Submit from '../View/Form/Submit'
import ZenkakuToHankaku from '../View/Form/ZenkakuToHankaku'
import HasCounter from '../View/Form/HasCounter'
import Select2 from '../View/Form/Select2'
import DatePicker from '../View/Form/DatePicker'
import DeleteItem from '../View/Form/DeleteItem'
import Editor from '../View/Form/Editor'
import DatepickerClose from '../View/Form/DatepickerClose'
import ImageRotate from '../View/Form/ImageRotate'
import ChangeRotate from '../View/Form/ChangeRotate'
import DeletePhoto from '../View/Form/DeletePhoto'

// 作った：汎用的な機能
import AddTemplate from '../View/Form/AddTemplate'
import UploadPhoto from '../View/Form/UploadPhoto'
import UploadPhotoMultiple from '../View/Form/UploadPhotoMultiple'
import OpenConfirmModal from '../View/Form/OpenConfirmModal'
import TogglePassword from '../View/Form/TogglePassword'
import InputTextareaResize from '../View/Form/InputTextareaResize'
import CheckActivation from '../View/Form/CheckActivation'
import EditorTest from '../View/Form/EditorTest'
import PreviewArticle from '../View/Form/PreviewArticle'
import PreventExit from '../View/Form/PreventExit'

// 作った：プロジェクト固有の機能
import ObserveChangeForAccess from '../View/Form/ObserveChangeForAccess'
import ChangeEmploymentStatus from '../View/Form/ChangeEmploymentStatus'
import ChangeSalaryType from '../View/Form/ChangeSalaryType'
import ChangeSearchItemPrefecture from '../View/Form/ChangeSearchItemPrefecture'
import CreateMapLink from '../View/Form/CreateMapLink'
import JumpGoogleMap from '../View/Form/JumpGoogleMap'
import AddRecommendForm from '../View/Form/AddRecommendForm'
import OccupationRadioInput from '../View/Form/OccupationRadioInput'
import WorkingTimePattern from '../View/Form/WorkingTimePattern'
import InputOpenStatus from '../View/Form/InputOpenStatus'
import EditReadOnly from '../View/Form/EditReadOnly'
import ChangeSalary from '../View/Form/ChangeSalary'
import ChangeManagerFlag from '../View/Form/ChangeManagerFlag'

$(() => {
	const FormController = new Form()
	// validate
	$('.validate').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Validate, $e, [$e, FormController])
	})
	// 全角→半角変換
	$('.zen2han').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ZenkakuToHankaku, $e, [$e, FormController])
	})
	// カウンター
	$('.has-counter').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(HasCounter, $e, [$e, FormController])
	})
	// submit
	$('[type=submit][data-form]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Submit, $e, [$e, FormController])
	})
	// 削除確認モーダルを開く
	$('.btn-delete-item').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(DeleteItem, $e, [$e, FormController])
	})
	// select2
	$('.select2').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Select2, $e, [$e, FormController])
	})
	// Air  Datepicker
	$('[data-datepicker=true]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(DatePicker, $e, [$e, FormController])
	})
	//  写真削除
	$('.btn-delete-photo').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(DeletePhoto, $e, [$e, FormController])
	})
	// EditorJS
	$('#codex-editor').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(Editor, $e, [$e, FormController])
	})
	// プレビュー
	$('.btn-article-preview').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(PreviewArticle, $e, [$e, FormController])
	})
	// datepickerクリア
	$('.btn-datepicker-close').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(DatepickerClose, $e, [$e, FormController])
	})
	// 掲示板画像回転
	$('[data-rotate=90]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ImageRotate, $e, [$e, FormController])
	})
	$('[data-rotate=270]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ImageRotate, $e, [$e, FormController])
	})
	// サムネイル回転
	$('#rotate').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ChangeRotate, $e, [$e, FormController])
	})
	// パスワードの表示・非表示切り替え
	$('.btn-toggle-password').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(TogglePassword, $e, [$e, FormController])
	})
	// テキストエリアの入力を監視しリサイズする
	$('.input-textarea-resize').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(InputTextareaResize, $e, [$e, FormController])
	})
	// 対象フォームをコピーして増やす
	$('[data-template-area-type="wrap"]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(AddTemplate, $e, [$e, FormController])
	})
	// select2のフォームを増やす
	$('[data-template-area-type="wrap-recommend"]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(AddRecommendForm, $e, [$e, FormController])
	})
	// チェックボックスでinputエリアを活性化
	$('[data-check-activation-type="wrap"]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(CheckActivation, $e, [$e, FormController])
	})
	// 最寄駅とアクセスの値を同期
	$('.observe-change-for-access').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ObserveChangeForAccess, $e, [$e, FormController])
	})
	// 雇用形態の変更を監視
	$('.input-select-employment-status').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ChangeEmploymentStatus, $e, [$e, FormController])
	})
	// 給与の変更を監視
	$('.input-select-salary-type').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ChangeSalaryType, $e, [$e, FormController])
	})
	// 都道府県のセレクトボックス又は、郵便番号の値を監視
	$('.p-postal-code, .input-select-prefecture-pair-spot').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ChangeSearchItemPrefecture, $e, [$e, FormController])
	})
	// ファイルアップロード
	$('.block-file-upload').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(UploadPhoto, $e, [$e, FormController])
	})
	// ファイルアップロード(multiple)
	$('.block-file-upload-multiple').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(UploadPhotoMultiple, $e, [$e, FormController])
	})
	// 住所からgoogle mapのリンク先を作成
	$('.btn-create-map-link').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(CreateMapLink, $e, [$e, FormController])
	})
	// google mapのリンク先へ飛ぶ
	$('.btn-jump-map-link').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(JumpGoogleMap, $e, [$e, FormController])
	})
	// 確認モーダルを開いた時にモーダル内のformにinput要素を追加する
	$('.btn-open-confirm-modal').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(OpenConfirmModal, $e, [$e, FormController])
	})
	// EditorJsの確認用
	$('.btn-editor-test').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(EditorTest, $e, [$e, FormController])
	})
	// 離脱防止アラート
	$('.prevent-exit').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(PreventExit, $e, [$e, FormController])
	})
	// 職種選択のラジオボタンの変更を監視
	$('.occupation-radio-form').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(OccupationRadioInput, $e, [$e, FormController])
	})
	// シフトパターンによって勤務時間項目を変える
	$('.working_time_pattern').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(WorkingTimePattern, $e, [$e, FormController])
	})
	// 公開・非公開の挙動
	$('.inputOpenStatus').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(InputOpenStatus, $e, [$e, FormController])
	})
	// 編集権限のない場合に編集画面はreadonlyにする
	$('body.readonly').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(EditReadOnly, $e, [$e, FormController])
	})
	// 見込み月給上限、下限の変更を監視
	$('.expected_monthly_salary').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ChangeSalary, $e, [$e, FormController])
	})
	// 案件担当可否変更
	$('[name=manager_flag]').each((idx, e) => {
		const $e = $(e)
		ApplyClass.apply(ChangeManagerFlag, $e, [$e, FormController])
	})
})
